import { render, staticRenderFns } from "./unknown-keyword.vue?vue&type=template&id=1724cec6&scoped=true&"
import script from "./unknown-keyword.vue?vue&type=script&lang=js&"
export * from "./unknown-keyword.vue?vue&type=script&lang=js&"
import style0 from "./unknown-keyword.vue?vue&type=style&index=0&id=1724cec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724cec6",
  null
  
)

export default component.exports